import React from 'react';
import { LocationIds, EquipmentDiscounts, OfferTypes } from  './../constants/actionType';
import PromoMessage from './../constants/promoMessage';
import { InHomeUtils } from './../util/inhomeUtils';

class promoContent extends React.PureComponent {
        
    render() {
        let template = <div></div>;
        let promoOffers = '';
        let rewardOffersText = '';
        let isFCP = false;
        let selectedDataService = '';
        let selectedTvService = '';
                      
        if(this.props.locationId !== '' && InHomeUtils.isNotNull(this.props.cartData)){
            let isCartRewardOffers = (InHomeUtils.isNotNull(this.props.cartData.rewardOffers) && InHomeUtils.isNotNull(this.props.cartData.rewardOffers.rewardOffers) && this.props.cartData.rewardOffers.rewardOffers.length > 0) ? true : false;
            let isCartPromotions = (InHomeUtils.isNotNull(this.props.cartData.Promotions) && InHomeUtils.isNotNull(this.props.cartData.Promotions.promotions) && this.props.cartData.Promotions.promotions.length > 0) ? true : false;

            if(isCartRewardOffers){
                this.props.cartData.rewardOffers.rewardOffers.map((rewardItem) => {
                    if(this.props.locationId !== undefined && this.props.locationId === LocationIds.contractText){
                        if(rewardOffersText.length === 0 ){
                            rewardOffersText += rewardItem.promoText;
                        }else{
                            rewardOffersText += ", ";
                            rewardOffersText += rewardItem.promoText;
                        }
                    } else{
                        if(promoOffers.length === 0 ){
                            promoOffers += (InHomeUtils.isNotEmpty(rewardItem.promotionId)) ? rewardItem.promotionId + '~' + rewardItem.offerId : rewardItem.offerId;
                        }else{
                            promoOffers += "|";
                            promoOffers += (InHomeUtils.isNotEmpty(rewardItem.promotionId)) ? rewardItem.promotionId + '~' + rewardItem.offerId : rewardItem.offerId;
                        }
                    }
                });
            }

            //FCP EQUIPMENT Promo
            if(isCartPromotions){
                switch (this.props.locationId) {
                    case LocationIds.RouterHeader:
                    case LocationIds.setTopBoxHeader:
                    case LocationIds.dvrHeader:
                        this.props.cartData.Promotions.promotions.map((promoItem) => {
                            if(promoItem.offerAttr === "EQUIPMENT"){
                                if((this.props.locationId === LocationIds.RouterHeader && promoItem.offerAttrValue === "FCP_ROUTER_DISCOUNT")
                                ||(this.props.locationId === LocationIds.RouterHeader && promoItem.offerAttrValue === EquipmentDiscounts.whw)
                                ||(this.props.locationId === LocationIds.setTopBoxHeader && promoItem.offerAttrValue === EquipmentDiscounts.vRoom)
                                ||(this.props.locationId === LocationIds.dvrHeader && promoItem.offerAttrValue === EquipmentDiscounts.recording)
                                ||(this.props.locationId === LocationIds.dvrHeader && promoItem.offerAttrValue === EquipmentDiscounts.recordingEmpMM2)){
                                    isFCP = true;
                                    if(promoOffers.length === 0 ){
                                        promoOffers += (InHomeUtils.isNotEmpty(promoItem.promotionId)) ? promoItem.promotionId + '~' + promoItem.offerId : promoItem.offerId;
                                    }else{
                                        promoOffers += "|";
                                        promoOffers += (InHomeUtils.isNotEmpty(promoItem.promotionId)) ? promoItem.promotionId + '~' + promoItem.offerId : promoItem.offerId;
                                    }
                                }
                            }
                        }); 
                        break;
                                       
                    default:
                       
                        break;
                }
                
                if(isFCP && this.props.cartData && this.props.cartData.serviceHeaders && this.props.cartData.serviceHeaders.servicehead){
                    if(this.props.locationId === LocationIds.setTopBoxHeader || this.props.locationId === LocationIds.dvrHeader){
                        this.props.cartData.serviceHeaders.servicehead.map((servItem) => {
                            if(servItem.prodType === "BASIC"){
                                selectedTvService = servItem.prodName;
                            }
                        });
                    }

                    if(this.props.locationId === LocationIds.RouterHeader){
                        this.props.cartData.serviceHeaders.servicehead.map((servItem) => {
                            if(servItem.prodType === "FTTPD"){
                                selectedDataService = servItem.prodName;
                            }
                        });
                    }
                }
            }
            
            if(isCartPromotions && this.props.locationId === LocationIds.contractText){
                let grubHubOffer = false;
                this.props.cartData.Promotions.promotions.map((promoItem) => {
                    if(promoItem.offerAttr === OfferTypes.SpecialDiscount && promoItem.offerAttrValue === OfferTypes.Grubhub){
                        grubHubOffer = true;
                    }
                }); 
                if(grubHubOffer) {
                    rewardOffersText += (", Fios Grubhub Reward");
                }
            }

            if(this.props.locationId === '100'){
                template = <PromoMessage message={rewardOffersText} />;
            }else{
                if(this.props.locationId === LocationIds.streamingDevicesHeader){
                    promoOffers = 'StreamingServices';
                }
                
                let disclaimerFragment = '';
                if (promoOffers !== '') {
                    let promoText = '';
                    let arrPromoText = [];
                    let arrPromoOffers = promoOffers.split("|");
                    arrPromoOffers.forEach(promoItem => {
                        if(InHomeUtils.isNotNull(this.props.buildProductContent) && InHomeUtils.isNotNull(this.props.buildProductContent.disclaimerContentFragments) && InHomeUtils.isNotNull(this.props.buildProductContent.disclaimerContentFragments[promoItem])){
                            disclaimerFragment = this.props.buildProductContent.disclaimerContentFragments[promoItem];

                            if (InHomeUtils.isNotNull(disclaimerFragment) && InHomeUtils.isNotEmpty(disclaimerFragment.promo)  && disclaimerFragment.promo !== "<p>N/A</p>"){
                                if(InHomeUtils.isNotEmpty(disclaimerFragment.location) && disclaimerFragment.location === this.props.locationId) {
                                    arrPromoText.push(disclaimerFragment.promo);
                                }
                            }
                        }
                    });

                    //Sorting promo list start
                    // if(arrPromoText.length > 1){
                    //     let promoIndex = 0;
                    //     let lastPromoIndex = 0;
                    //     arrPromoText.forEach(promoItem => {
                    //         if(promoItem.indexOf("with") !== -1){
                    //             lastPromoIndex = promoIndex;
                    //         }
                    //         promoIndex++;
                    //     });

                    //     if(lastPromoIndex !== lastPromoIndex.length){
                    //         let temp = arrPromoText[lastPromoIndex];
                    //         arrPromoText[lastPromoIndex] = arrPromoText[arrPromoText.length - 1];
                    //         arrPromoText[arrPromoText.length - 1] = temp;
                    //     }
                    // }
                    //Sorting promo list end

                    if(arrPromoText.length > 0){
                        arrPromoText.sort(function(x,y){ return x.indexOf('Plus') === 0 ? 1 : y.indexOf('Plus') === 0 ? -1 : 0; });
                        let promoSortedIndex = 0;
                        arrPromoText.forEach(promoItem => {
                            if(promoSortedIndex === 0 ){
                                promoText = promoItem;
                            }else{
                                promoText += promoItem.indexOf('Plus') === 0 ? ". " : ", ";
                                promoText += promoItem.replace("Includes ", "");
                            }
                            promoSortedIndex++;
                        });
                    }

                    if(promoText.length > 0){
                        if(isFCP){
                            if(selectedTvService !== ''){
                                if(this.props.locationId === LocationIds.setTopBoxHeader){
                                    promoText = promoText.replace("More Fios TV", selectedTvService)
                                }else if(this.props.locationId === LocationIds.dvrHeader){
                                    promoText = promoText.replace("The Most Fios TV", selectedTvService)
                                }
                            }
                            if(selectedDataService !== ''){
                                if(this.props.locationId === LocationIds.RouterHeader){
                                    promoText = promoText.replace("Gigabit Internet", selectedDataService)
                                }
                            }
                        }

                        if(isCartPromotions && this.props.locationId === LocationIds.internetHeader){
                            let routerRentalOffer = false;
                            this.props.cartData.Promotions.promotions.map((promoItem) => {
                                if(promoItem.offerAttr === "PRICING" && promoItem.offerAttrValue === "100PERCENT" && promoItem.promoText.toLowerCase().indexOf("router rental") !== -1){
                                    routerRentalOffer = true;
                                }
                            }); 
                            if(!routerRentalOffer) {
                                promoText = promoText.replace(", free router rental", "");
                            }
                        }

                        template = <PromoMessage message={promoText} />;
                    }
                }
            }
        }
                
        return (
            <React.Fragment>
              {template}
           </React.Fragment>
        )
    }
}
export default promoContent;